/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateNewSupplierMutationVariables = Types.Exact<{
  input: Types.CopySupplierOrganisationAsCrmInput;
}>;


export type CreateNewSupplierMutation = { copySupplierOrganisationAsCrm: { __typename: 'CopySupplierOrganisationAsCrmResult', crmOrganisation: { __typename: 'CrmCompany', id: string, number: string, title: string, email: any, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } } };

export type SubscribeToSupplierMutationVariables = Types.Exact<{
  input: Types.PimSubscribeToSupplierInput;
}>;


export type SubscribeToSupplierMutation = { pimSubscribeToSupplier: { __typename: 'PimSubscribeToSupplierResult', supplier: { __typename: 'PimSupplier', id: string, subscribed: boolean } } };


export const CreateNewSupplierDocument = gql`
    mutation CreateNewSupplier($input: CopySupplierOrganisationAsCrmInput!) {
  copySupplierOrganisationAsCrm(input: $input) {
    crmOrganisation {
      id
      number
      title
      logo {
        ...AttachmentSnapshot
      }
      email
      contactPerson {
        id
        fullname
      }
      billingAddress {
        ...AddressDetails__Address
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}
${AddressDetails__AddressFragmentDoc}`;
export type CreateNewSupplierMutationFn = Apollo.MutationFunction<CreateNewSupplierMutation, CreateNewSupplierMutationVariables>;

/**
 * __useCreateNewSupplierMutation__
 *
 * To run a mutation, you first call `useCreateNewSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewSupplierMutation, { data, loading, error }] = useCreateNewSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewSupplierMutation, CreateNewSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewSupplierMutation, CreateNewSupplierMutationVariables>(CreateNewSupplierDocument, options);
      }
export type CreateNewSupplierMutationHookResult = ReturnType<typeof useCreateNewSupplierMutation>;
export type CreateNewSupplierMutationResult = Apollo.MutationResult<CreateNewSupplierMutation>;
export type CreateNewSupplierMutationOptions = Apollo.BaseMutationOptions<CreateNewSupplierMutation, CreateNewSupplierMutationVariables>;
export const SubscribeToSupplierDocument = gql`
    mutation SubscribeToSupplier($input: PimSubscribeToSupplierInput!) {
  pimSubscribeToSupplier(input: $input) {
    supplier {
      id
      subscribed
    }
  }
}
    `;
export type SubscribeToSupplierMutationFn = Apollo.MutationFunction<SubscribeToSupplierMutation, SubscribeToSupplierMutationVariables>;

/**
 * __useSubscribeToSupplierMutation__
 *
 * To run a mutation, you first call `useSubscribeToSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToSupplierMutation, { data, loading, error }] = useSubscribeToSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToSupplierMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToSupplierMutation, SubscribeToSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToSupplierMutation, SubscribeToSupplierMutationVariables>(SubscribeToSupplierDocument, options);
      }
export type SubscribeToSupplierMutationHookResult = ReturnType<typeof useSubscribeToSupplierMutation>;
export type SubscribeToSupplierMutationResult = Apollo.MutationResult<SubscribeToSupplierMutation>;
export type SubscribeToSupplierMutationOptions = Apollo.BaseMutationOptions<SubscribeToSupplierMutation, SubscribeToSupplierMutationVariables>;